import Vue from 'vue';
import {
    Message,
    MessageBox,
    Loading,
    Dialog,
    Button,
    Scrollbar,
    Form,
    FormItem,
    Input,
    DatePicker,
    Radio,
    RadioGroup,
    Pagination,
    Row,
    Backtop,
    Table,
    TableColumn,
    Col,
    Select,
    Option,
    Tooltip,
    Collapse,
    Image,
    Progress,
    Switch,
    Popover,
    Dropdown,
    DropdownMenu,
    DropdownItem
  } from 'element-ui';

  Vue.use(DropdownItem);
  Vue.use(DropdownMenu);
  Vue.use(Dropdown);
  Vue.use(Popover);
  Vue.use(Switch);
  Vue.use(Progress);
  Vue.use(Image);
  Vue.use(Collapse);
  Vue.use(Tooltip);
  Vue.use(Option);
  Vue.use(Select);
  Vue.use(Col);
  Vue.use(TableColumn);
  Vue.use(Table);
  Vue.use(Backtop);
  Vue.use(Row);
  Vue.use(Pagination);
  Vue.use(RadioGroup);
  Vue.use(Radio);
  Vue.use(DatePicker);
  Vue.use(Input);
  Vue.use(FormItem);
  Vue.use(Form);
  Vue.use(Image);
  Vue.use(Scrollbar);
  Vue.use(Button);
  Vue.use(Dialog);
  Vue.use(Loading);
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

// import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/element-variables.scss'